import api from '../../../services/api';
import { toAnalyticsParams } from '../../../components/performance/pmAnalyticsFilters';

// PM analitik P7b — E19 Görüşme ve Süreç Deneyimi veri katmanı (İK + yönetici). Uçlar:
//   GET v1/performance-experience/summary?…F0          (M63–M69, aşama çubukları, anonim anket dağılımı)
//   GET v1/performance-experience/meetings?…F0&…       (görüşme/teyit iş listesi; itiraz yalnız İK; anket katılımı YOK)
//   GET v1/performance-experience/survey-groups?…&dimension=department|title|manager (anonim soru × grup, k gizleme)
//   PUT v1/performance-experience/meetings/{participantId} (yalnız doğrudan yönetici: planla / gerçekleşti kaydet)
// api.js GET'te reject ETMEZ — hata sinyali res.data.status.

const BASE = '/v1/performance-experience';

export class ExperienceError extends Error {}

const payload = (res) => (res?.data?.status ? res.data.data : undefined);

async function get(url, params) {
  const res = await api.get(url, { params });
  const data = payload(res);
  if (data === undefined) throw new ExperienceError(res?.data?.message || 'error');
  return data;
}

export const KPI_CODES = ['M63', 'M64', 'M65', 'M66', 'M67', 'M68', 'M69'];
export const QUESTIONS = ['clarity', 'fairness', 'usefulness'];
export const SURVEY_DIMENSIONS = ['department', 'title', 'manager'];
export const MEETING_STATUSES = ['not_planned', 'planned', 'held', 'cancelled'];
export const CONFIRMATION_STATUSES = ['confirmed', 'not_confirmed', 'outdated'];
export const MEETING_DUE = ['overdue', 'week'];
export const OBJECTION_STATUSES = ['open', 'accepted', 'rejected', 'none'];

export const fetchSummary = (filters) => get(`${BASE}/summary`, toAnalyticsParams(filters));

export function meetingParams(filters, local, page) {
  const params = { ...toAnalyticsParams(filters), pageNumber: page.pageNumber, pageSize: page.pageSize };
  if (local.meetingStatus) params['meetingStatus[eq]'] = local.meetingStatus;
  if (local.confirmation) params['confirmation[eq]'] = local.confirmation;
  if (local.meetingDue) params['meetingDue[eq]'] = local.meetingDue;
  if (local.objection) params['objection[eq]'] = local.objection;
  return params;
}

export const fetchMeetings = (filters, local, page) => get(`${BASE}/meetings`, meetingParams(filters, local, page));

export const fetchSurveyGroups = (filters, dimension) => get(`${BASE}/survey-groups`, { ...toAnalyticsParams(filters), dimension });

/** Görüşme kaydı (mutasyon): hata durumunda interceptor uyarır ve reddeder — çağıran yalnız sonucu (true/false) kullanır. */
export async function recordMeeting(participantId, body) {
  try {
    const res = await api.put(`${BASE}/meetings/${participantId}`, body);
    return !!res?.data?.status;
  } catch {
    return false;
  }
}

export const metricOf = (list, code) => (list || []).find((m) => m.metricCode === code) || null;
export const hasValue = (m) => !!m && m.value != null && !m.suppressionReason;
export const formatNumber = (v, lang, digits = 2) => (v == null ? '' : new Intl.NumberFormat(lang, { maximumFractionDigits: digits }).format(Number(v)));

/** Aşama çubukları: her aşama kendi paydasıyla (analiz §32 orta sol — payda tooltip/tabloda ayrı). */
export function stageBars(stages) {
  if (!stages) return [];
  return [
    { key: 'published', value: stages.published, denominator: stages.published },
    { key: 'meetingDue', value: stages.meetingDue, denominator: stages.published },
    { key: 'meetingHeld', value: stages.meetingHeld, denominator: stages.meetingDue },
    { key: 'confirmedOfHeld', value: stages.confirmedOfHeld, denominator: stages.meetingHeld },
  ];
}

/** Anket dağılımı (1–5) + olumlu %4–5; gizlenmiş soru boş satır döner. */
export function surveyRows(questions) {
  return (questions || []).map((q) => {
    const dist = q.distribution || [];
    const row = { key: q.key, metricCode: q.metricCode, validN: q.validN, positive: q.positive, suppressed: !!q.suppressionReason, reason: q.suppressionReason };
    [1, 2, 3, 4, 5].forEach((v, i) => { row[`s${v}`] = dist[i] ?? null; });
    row.positivePct = q.validN ? Math.round((10000 * (q.positive || 0)) / q.validN) / 100 : null;
    return row;
  });
}
